var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageContainer',{attrs:{"isFullscreen":"true","isLoading":_vm.isLoading,"error":_vm.error}},[_c('MapContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }